import ReactDOM from 'react-dom';
import moment from 'moment';
import locale from 'moment/locale/pt-br';

import App from './App';

moment.updateLocale('pt-br', locale);

export const isAppPortocar = process.env.REACT_APP_APPLICATION === 'PORTOCAR';
export const APP_NAME = isAppPortocar
  ? 'Centro Automotivo Porto Serviços'
  : 'Ultracar';

ReactDOM.render(<App />, document.getElementById('root'));
